/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type DashboardImpersonationControllerImpersonate403AllOfErrorCode =
  (typeof DashboardImpersonationControllerImpersonate403AllOfErrorCode)[keyof typeof DashboardImpersonationControllerImpersonate403AllOfErrorCode];

export const DashboardImpersonationControllerImpersonate403AllOfErrorCode = {
  FORBIDDEN: "FORBIDDEN",
  IMPERSONATION_TARGET_NO_APP_ACCESS: "IMPERSONATION_TARGET_NO_APP_ACCESS",
} as const;
